import Cookies from 'js-cookie';

export type CurrentUser = {
  accessToken: string;
  client: string;
  uid: string;
  expiry: string;
};

export const getCurrentUser: () => CurrentUser | null = () => {
  const accessToken = Cookies.get('_accessToken');
  const client = Cookies.get('_client');
  const uid = Cookies.get('_uid');
  const expiry = Cookies.get('_expiry');

  if (accessToken && client && uid && expiry) {
    return { accessToken, client, uid, expiry };
  }

  return null;
};

export const resetCurrentUser = () => {
  Cookies.remove('_accessToken');
  Cookies.remove('_client');
  Cookies.remove('_uid');
  Cookies.remove('_expiry');
};
